import React from 'react';
import RenderCard from './CardComponent';
import { FadeTransform } from 'react-animation-components';

const Home = (props) => {
    return (
        <div className="container">
            <FadeTransform in transformProps={{
                exitTransform: 'scale(0.5) TranslateY(-50%)'
            }}>
                <div className="row">
                    <div className="col-12 col-md mt-1 mb-1">
                        <RenderCard className item={props.dish} isLoading={props.dishesLoading}
                            errMessage={props.dishesErrMessage} />
                    </div>
                    <div className="col-12 col-md mt-1 mb-1">
                        <RenderCard item={props.promotion} isLoading={props.promosLoading}
                            errMessage={props.promosErrMessage} />
                    </div>
                    <div className="col-12 col-md mt-1 mb-1">
                        <RenderCard item={props.leader} isLoading={props.leadersLoading}
                            errMessage={props.leadersErrMessage} />
                    </div>
                </div>
            </FadeTransform>
        </div>
    );
}

export default Home;